import routes from "./router/routes"
import occHealthStore from "./store/occupational-health-store"

export function occupationalHealthModule({ store, router }) {
  for (const route of routes) router.addRoute("dashboard", route)

  store.registerModule("occupational-health-store", occHealthStore)
}
